<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>User Staff</h5>
            </template>
            <div class="search-wrapper d-flex align-items-center justify-content-between">
                <b-form-group
                    label="Filter"
                    label-for="filterInput"
                    class="form-inline form-group-wrapper mb-3"
                >
                    <div class="d-flex search-input-wrapper">
                        <multiselect class="ml-2 mr-2" v-model="input.filterLevel"
                            id="filterInput" name="levelRole" :options="optionRole"
                            :internal-search="true" :allow-empty="true" deselect-label=""
                            select-label="" label="name" track-by="id"
                            placeholder="Level - Role" />
                        <b-form-input class="mr-2"
                            v-model="input.filterName" name="filterTable"
                            type="search"
                            id="filterInput"
                            placeholder="Nama Lengkap"
                            @keyup.enter="onFilter" 
                            ></b-form-input>
                        <b-form-input class="mr-2"
                            v-model="input.filterUsername" name="filterUsername"
                            type="search"
                            id="filterUsername"
                            placeholder="NIK / Username"
                            @keyup.enter="onFilter" 
                            ></b-form-input>
                        <b-button class="mr-2" variant="pgiBtn" :disabled="isBusy" name="searchTableBtn" @click="onFilter"> 
                            <i class="fa fa-search"></i>
                        </b-button>
                        <b-button variant="pgiBtn" name="reseFilterBtn" :disabled="isBusy" @click="onReset">Reset</b-button>
                    </div>
                </b-form-group>
                <b-button class="mb-3" variant="pgiBtn" name="userStaffAddBtn" @click="inputUserStaff">Input User Staff</b-button>
            </div>
            <b-table bordered hover show-empty
                :busy="isBusy"
                :items="userStaff"
                :fields="fields" 
                :no-local-sorting="false"
                @sort-changed="sortingChanged" 
                responsive class="mb-3">
                <template v-slot:table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>  Loading data...</strong>
                    </div>
                </template>
                <template v-slot:empty>
                    Tidak ada data user staff.
                </template>
                <template v-slot:cell(role)="row">
                    {{row.item.role.level}} - {{row.item.role.name}}
                </template>
                <template v-slot:cell(cabang)="row" v-show="row.item.cabang != {}">
                    {{row.item.cabang.name}}
                </template>
                <template v-slot:cell(isActive)="row">
                    <b-badge variant="primary" class="p-2" v-if="row.item.isActive == true">Aktif</b-badge>
                    <b-badge variant="danger" class="p-2" v-else>Tidak Aktif</b-badge>
                </template>
                <template v-slot:cell(action)="row">
                    <div class="no-wrap">
                        <b-link :to="`${$route.path}/${row.item.id}`">
                            <b-button size="sm" class="mr-3 table-button view" v-b-tooltip.hover title="Detail" name="userStaffViewBtn">
                                <i class="fa fa-info"></i>
                            </b-button>
                        </b-link>
                        <b-link :to="`${$route.path}/${row.item.id}/edit`">
                            <b-button size="sm" class="table-button edit" v-b-tooltip.hover title="Edit" name="userStaffEditBtn">
                                <i class="fa fa-pencil-square-o"></i>
                            </b-button>
                        </b-link>
                    </div>
                </template>
            </b-table>

            <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
                    <b-form-select v-model="input.show" id="showItems" :options="options" @change="onLimitChange">
                        <template v-slot:first>
                            <b-form-select-option :value="null" disabled />
                        </template>
                    </b-form-select>
                    <span class="ml-2">{{ totalViewText }}</span>
                </b-input-group>
                <b-pagination class="mb-0"
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    aria-controls="my-table"
                    @input="onPageChange"
                ></b-pagination>
            </div>
        </b-card>
    </div>
</template>

<script>
export default {
    name: 'master-user-staff',
    data(){
        return{
            initStatus: 0,
            isBusy: true,
            input:{
                show: 10,
                filterLevel: null,
                filterName: null,
                filterUsername: null,
                sortBy: null,
                sortDesc: null
            },
            fields: [
                { key: "fullname", label: "Full Name", sortable:true},
                { key: "role", label: "Level", sortable:true},
                { key: "cabang", label: "Cabang", sortable:true},
                { key: "email", label: "Email", sortable:true},
                { key: "noHp", label: "No Hp", sortable:true},
                { key: "isActive", label: "Status", sortable:true},
                { key: "action", label: "Aksi"},
            ],
            userStaff: [{
                cabang: []
            }],
            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],
            optionRole: [],
            filter: null,
            currentPage: 1,
            perPage: 10,
            rows: null,
            totalViewText: "",
            page: '',
            size: '',
            loading: false,
            query: ""
        }
    }, 
    methods: {

        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.initStatus = 0
            this.page = 0
            this.size = this.input.show
            this.query = this.$helper.makeQuery(this.page, this.size)

            let getRole = this.$axios.get("role/").then(response => {
                this.optionRole = response.data

                for (var x of this.optionRole) {
                    x.name = "Level "+x.level+" - "+x.name
                }
            })
            
            let getUserStaff = this.$axios.get("user/"+this.query).then(response => {
                this.userStaff = response.data.data
                this.updateTotalItem(response.data.total)
            })

            Promise.all([getRole, getUserStaff]).then(() => {
                this.initStatus = 1
                this.toggleBusy()
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })
        },
        

        //----------------- Fungsi Ambil Data User Staff -----------------

        getUserStaff(){
            this.toggleBusy()
            this.userStaff = []
            
            if (this.input.filterLevel != null) this.query = this.query + "&filterRole=" + this.input.filterLevel.id
            if (this.input.filterName != null) this.query = this.query + "&filterName=" + this.input.filterName
            if (this.input.filterUsername != null) this.query = this.query + "&filterUsername=" + this.input.filterUsername
            if (this.input.sortBy != null) {
                if (this.input.sortBy == "fullname") this.query = this.query + "&sortBy=fullName"
                else this.query = this.query + "&sortBy=" + this.input.sortBy
            }
            if (this.input.sortDesc != null) this.query = this.query + "&sortDesc=" + this.input.sortDesc

            this.$axios.get("user/"+this.query).then(response => {
                this.userStaff = response.data.data
                this.toggleBusy()
                this.updateTotalItem(response.data.total)
                this.loading = false
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
                this.toggleBusy()
                this.loading = false
            })
        },


        //----------------- Fungsi Pagination, Sorting, dan loading -----------------

        onLimitChange(){
            this.size = this.input.show
            this.perPage = this.input.show
            this.currentPage = 1
            this.page = 0
            this.query = this.$helper.makeQuery(0, this.size)
            this.getUserStaff()
        },

        onPageChange(){
            if (this.loading == false){
                this.page = this.currentPage - 1
                this.query = this.$helper.makeQuery(this.page, this.size)
                this.getUserStaff()
            }
        },

        sortingChanged(ctx) {
            if(ctx.sortBy != ""){
                this.input.sortBy = ctx.sortBy
                this.input.sortDesc = ctx.sortDesc
                this.onFilter()
            }
        },

        onReset(){
            this.input.filterLevel = null
            this.input.filterName = null
            this.input.filterUsername = null
            this.currentPage = 1
            this.page = 0
            this.query = this.$helper.makeQuery(0, this.size)
            this.loading = true
            this.getUserStaff()
        },

        onFilter(){
            this.page = 0
            this.currentPage = 1
            this.query = this.$helper.makeQuery(0, this.size)
            this.loading = true
            this.getUserStaff()
        },
        

        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------
    
        toggleBusy() {
            if (this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },

        updateTotalItem(total){
            let limit = null
            let prevLimit = null
            this.perPage = this.size
            this.rows = total
            prevLimit = this.page * this.size + 1
            limit = this.page * this.size + this.size
            if (limit > this.rows) limit = this.rows
            this.totalViewText = "Menampilkan "+ prevLimit + " - " + limit + " dari " + this.rows + " entri"
        },

        inputUserStaff(){
            this.$router.push({path: `${this.$route.path}/input`});
        }

    },
    
    created(){
        this.init()
    }
}
</script>
